"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Not a Massively Great Map Space Wise as we do everything twice
class BiDirectionalMap {
    constructor() {
        this.ForwardMap = new Map();
        this.ReverseMap = new Map();
    }
    get size() {
        return this.ForwardMap.size;
    }
    set(key, value) {
        if (this.ForwardMap.has(key)) {
            let _value = this.ForwardMap.get(key);
            if (_value != null)
                this.ReverseMap.delete(_value);
        }
        if (this.ReverseMap.has(value)) {
            let _key = this.ReverseMap.get(value);
            if (_key != null)
                this.ForwardMap.delete(_key);
        }
        this.ForwardMap.set(key, value);
        this.ReverseMap.set(value, key);
    }
    get(key) {
        return this.ForwardMap.get(key);
    }
    getKey(value) {
        return this.ReverseMap.get(value);
    }
    clear() {
        this.ForwardMap.clear();
        this.ReverseMap.clear();
    }
    delete(key) {
        let value = this.ForwardMap.get(key);
        if (value == null)
            return;
        this.ForwardMap.delete(key);
        this.ReverseMap.delete(value);
    }
    deleteValue(value) {
        let key = this.ReverseMap.get(value);
        if (key == null)
            return;
        this.ForwardMap.delete(key);
        this.ReverseMap.delete(value);
    }
    entries() {
        return this.ForwardMap.entries();
    }
    has(key) {
        return this.ForwardMap.has(key);
    }
    hasValue(value) {
        return this.ReverseMap.has(value);
    }
    keys() {
        return this.ForwardMap.keys();
    }
    values() {
        return this.ForwardMap.values();
    }
}
exports.default = BiDirectionalMap;
